import { render } from "./student-status-new.vue?vue&type=template&id=408ab6b7"
import script from "./student-status-new.vue?vue&type=script&lang=js"
export * from "./student-status-new.vue?vue&type=script&lang=js"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__